import { Table, Button, Upload, message, Input } from 'antd';
import { useState, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { UploadOutlined } from '@ant-design/icons';
import { ExportCompaniesButton } from './components/ExportCompaniesButton';
import { useSelector } from 'react-redux';
import { Loader } from '../../components/Loader';
import { PageHeader } from '../../components/PageHeader';

import { defaultPageSize, apiUrl } from '../../settings/settings';

import { useCompanyListColumns } from './useCompanyListColumns';
import { useCompanyListData } from './useCompanyListData';

import { getUser, getUserRoles } from '../../redux/auth/selectors';

export const Companies = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [filterTable, setFilterTable] = useState();
  const { companyListData, companyListTotal, loading } = useCompanyListData();
  const columns = useCompanyListColumns();

  useLayoutEffect(() => {
    setFilterTable(companyListData);
  }, [companyListData]);

  const props = {
    name: 'file',
    action: apiUrl + 'companies/import',
    headers: {
      Authentication: `Bearer ${localStorage.getItem('token')}`,
      'x-api-key': 'SfCN4KQD3rhdU3zDdM9VKpNe',
    },
    beforeUpload: file => {
      const isCSV = file.type === 'text/csv';
      if (!isCSV) {
        message.error(`${file.name} is not a CSV file`);
      }
      return isCSV || Upload.LIST_IGNORE;
    },
    onChange(info) {
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
      return Upload.LIST_IGNORE;
    },
  };

  const user = useSelector(getUser);
  const userRoles = useSelector(getUserRoles);

  if (!user) {
    return <Navigate to={'/login'} />;
  }

  const search = value => {
    if (value == '') {
      setFilterTable(companyListData);
    }

    const filterTableData = companyListData.filter(o =>
      ['name', 'dhl_ids', 'tax_id'].some(k => String(o[k]).toLowerCase().includes(value.toLowerCase())),
    );

    setFilterTable(filterTableData);
  };

  const uploadButton = () => {
    if (userRoles.indexOf('admin') != -1) {
      return (
        <>
          <Upload {...props}>
            <Button icon={<UploadOutlined />}>{t('myCompanies.import')}</Button>
          </Upload>
          <ExportCompaniesButton />
        </>
      );
    }
    return <></>;
  };

  return (
    <>
      <PageHeader
        titleTranslationKey='companies.companies'
        extra={
          <>
            <Input.Search placeholder={t('myCompanies.search')} enterButton onSearch={search} />
            {uploadButton()}
          </>
        }
      />

      <Loader loading={loading}>
        <Table
          rowKey='_id'
          tableLayout='auto'
          dataSource={filterTable}
          columns={columns}
          loading={loading}
          scroll={{ x: 'max-content' }}
          pagination={{
            current: page,
            pageSize: defaultPageSize,
            total: companyListTotal,
            showTotal: total => t('global.tableTotal', { total }),
            showSizeChanger: false,
            hideOnSinglePage: true,
            onChange: setPage,
          }}
        />
      </Loader>
    </>
  );
};
